import {IStore, NullOrEmpty, IPlayer} from "modules/types";
import {createSelector} from "@reduxjs/toolkit";
import {memoize} from "lodash";
import {PlayerPositionEnum} from "modules/enums";
import {parseRequestState, parseStateType} from "modules/utils";
import {MAX_TEAM_COUNT} from "modules/constants";
import {getPlayers} from "modules/selectors/json";

const getState = ({teamReducer}: IStore) => teamReducer;

export const getTeam = createSelector(getState, (state) => state.team);

export const getPlayerByPosition = createSelector(getTeam, (team) => {
	return memoize((position: NullOrEmpty<PlayerPositionEnum>) => {
		if (!position) {
			return null;
		}
		return team[position];
	});
});

export const getPickedPlayersCounter = createSelector(getTeam, (team) => {
	return Object.values(team).filter(Boolean).length;
});

export const getPlayersCounter = createSelector(getTeam, (team) => Object.values(team).length);

export const getIsTeamFull = createSelector(getTeam, (team) => {
	return Object.values(team).every(Boolean);
});
export const getIsTeamEmpty = createSelector(getTeam, (team) => {
	return Object.values(team).every((item) => !item);
});

export const getIsPlayerInTeam = createSelector(getTeam, (team) => {
	return memoize((id: number = 0) => {
		return Object.values(team).includes(id);
	});
});

export const getIsPlayerInTeamByFeedId = createSelector(getTeam, getPlayers, (team, players) => {
	return memoize((player: IPlayer) => {
		return Boolean(
			Object.values(team).find((id) => {
				const teamPlayer = players.find((player) => player.id === id);
				return teamPlayer?.feedId === player.feedId;
			})
		);
	});
});

export const getIsTeamHasBeenChanged = createSelector(getState, (state) => state.isTeamChanged);

export const getTeamSavingRequestState = createSelector(getState, (state) =>
	parseStateType(state.saveRequestState)
);

export const getShareImage = createSelector(getState, (state) => state.shareImage);
export const getShareImageLoaded = createSelector(getState, (state) => state.shareImageLoaded);

export const getTeams = createSelector(getState, (state) => state.history);

export const getTeamsCount = createSelector(getTeams, (teams) => teams.length);

export const getIsAllTeamPicked = createSelector(
	getTeamsCount,
	(teamsCount) => teamsCount >= MAX_TEAM_COUNT
);

export const getIsLoadingTeam = createSelector(
	getState,
	({fetchRequestState}) => !parseRequestState(fetchRequestState).isComplete
);
